import { Injectable } from '@angular/core';
import { IS1PaginatedResult, IS1SearchParams, IS1TypedPaginatedResult, S1ApiCrudService, S1HttpClientService } from '@app/s1';
import { IStazione } from '../models/stazione';
import { map, Observable } from 'rxjs';

export interface IRicercaStazioneParams extends IS1SearchParams, Partial<IStazione> { }

export interface IRicercaStazioniEntrataParams extends IS1SearchParams {
  idStazioneUscita: string,
  data: Date
}

enum StazioniApi {
  ricercaStazioniEntrata = "/RicercaStazioniEntrata"
}

@Injectable({
  providedIn: 'root'
})
export class StazioneService extends S1ApiCrudService<IStazione, IRicercaStazioneParams> {

  constructor(s1HttpClient: S1HttpClientService) { 
    super(s1HttpClient, "/stazione");
  }

  ricercaStazioniEntrata(params: IRicercaStazioniEntrataParams): Observable<IS1TypedPaginatedResult<IStazione>> {

    return this.s1HttpClient.post(this.path + StazioniApi.ricercaStazioniEntrata, params).pipe(
      map(response => {
        return  { 
          elements: response.results,
          paginationInfo: response.paginationInfo
        } as IS1TypedPaginatedResult<IStazione>
      })
    )

  }

}
